import React, { useState } from 'react';

import Filters from '../components/Filters'
import CardList from '../components/CardList';
import SideBar from '../components/SideBar';
import Navbar from '../components/Navbar';

const Home = () => {

  const [selectedCards, setSelectedCards] = useState([]);

  return (
    <main>
      <div className="SideBar">
        <SideBar />
      </div>
      <div className="content">
        <Navbar />
        <Filters setSelectedCards={setSelectedCards} />
        <div className="FilterContainer">
          <CardList selectedCards={selectedCards} />
        </div>
      </div>
    </main>
  );
};

export default Home;
